import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

export default class SubscriptionPlan extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "subscription-plan";
    static pluralName = "subscription-plans";

    constructor() {
        super(SubscriptionPlan.kind, SubscriptionPlan.singularName, SubscriptionPlan.pluralName);
    }

    async getCatalog() {
        return this.action("", "/subscription-plans/catalog");
    }
}
